import type { ReactNode } from 'react';
import { Stack, Typography, type SxProps, type Theme } from '@mui/material';

export type MobileHeaderTitleProps = {
  children: ReactNode;
  variant?: 'target';
  subtitle?: ReactNode;
  subtitleSx?: SxProps<Theme>;
  subtitleDataQaElementId?: string;
  end?: ReactNode;
  sx?: SxProps<Theme>;
  'data-qa-element-id'?: string;
};

const targetTitleSx = {
  justifyContent: 'flex-start',
  textAlign: 'start',
  overflowWrap: 'break-word',
  pb: 0.5,
  height: 50,
} satisfies SxProps<Theme>;

const targetSubtitleSx = {
  color: 'inherit',
  opacity: 0.65,
  lineHeight: 1,
  textOverflow: 'ellipsis',
  whiteSpace: 'break-spaces',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  lineClamp: '2',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
} satisfies SxProps<Theme>;

export function MobileHeaderTitle({
  children,
  variant,
  subtitle,
  subtitleSx,
  subtitleDataQaElementId,
  end,
  sx,
  'data-qa-element-id': dataQaElementId,
}: MobileHeaderTitleProps) {
  const hasEnd = end !== undefined;
  const titleSx = variant === 'target' ? [targetTitleSx, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])] : sx;
  const resolvedSubtitleSx =
    variant === 'target'
      ? [targetSubtitleSx, ...(subtitleSx ? (Array.isArray(subtitleSx) ? subtitleSx : [subtitleSx]) : [])]
      : subtitleSx;

  const title = (
    <Typography variant="h6" data-qa-element-id={dataQaElementId}>
      {children}
    </Typography>
  );

  return (
    <Stack minWidth={0} sx={titleSx}>
      {hasEnd ? (
        <Stack direction="row" alignItems="center" gap={1} justifyContent="space-between">
          <Stack minWidth={0} flex={1}>
            {title}
          </Stack>
          {end}
        </Stack>
      ) : (
        title
      )}
      {subtitle !== undefined && (
        <Typography
          variant="subtitle2"
          color="text.secondary"
          component="div"
          sx={resolvedSubtitleSx}
          data-qa-element-id={subtitleDataQaElementId}
        >
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
}
